import {
  Button,
  ButtonGroup,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

import CachedIcon from "@mui/icons-material/Cached";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useMaterialUIController } from "context";
import { useState } from "react";
import getText from "Translator";

let clearError = false;
export default function TextComponent(props) {
  const [error, setError] = useState(false);
  const {
    question,
    fileInfo,
    editQuestionHandle,
    helpPage,
    openSelectList,
    setFocuse,
  } = props;
  const [controller, dispatch] = useMaterialUIController();
  const renderAllowCopy = () => {
    return (
      <ContentCopyIcon
        onClick={async () => {
          if (question.useranswer == question.copyValue) {
            editQuestionHandle(question, "");
          } else {
            editQuestionHandle(question, question.copyValue);
          }
        }}
        style={{
          color: "#039dfc",
          height: 18,
          width: 18,
          marginTop: -45,
          marginInlineEnd: -10,
          cursor: "pointer",
          zIndex: 12,
        }}
      />
    );
  };
  return (
    <Grid
      item
      xs={
        question.fixTop || question.fixBottom 
          ? 12
          : question.size
          ? question.size
          : 12
      }
      sm={
        question.fixTop || question.fixBottom
          ? 12
          : question.size
          ? question.size
          : 12
      }
      md={
        question.fixTop || question.fixBottom
          ? 12
          : question.size
          ? question.size
          : 12
      }
      style={{
        position: question.fixTop || question.fixBottom ? "fixed" : "unset",
        left: question.fixTop || question.fixBottom ? 0 : "unset",
        right: question.fixTop || question.fixBottom ? 0 : "unset",
        top: question.fixTop ? 0 : "unset",
        bottom: question.fixBottom ? 0 : "unset",
        paddingBottom: question.fixTop || question.fixBottom ? 10 : "unset",
        backgroundColor:
          question.fixTop || question.fixBottom ? "#FFF" : "unset",
        zIndex: question.fixTop || question.fixBottom ? 999 : "unset",
        paddingTop: question.fixTop ? 55 : question.fixBottom ? 10 : "unset",
        paddingBottom: question.fixBottom ? 55 : question.fixTop ? 10 : "unset",
        paddingRight: question.fixTop || question.fixBottom ? 15 : "unset",
        paddingLeft: question.fixTop || question.fixBottom ? 15 : "unset",

        marginTop:
          question.titleType === 2 ? 8 : question.displayTitle ? 5 : 8,
        marginBottom: question.helpPage ? -15 : 0,
        display: question.visible ? "" : "none",
        cursor: "pointer",
        paddingInlineEnd: question.size && question.size !== 12 ? 3 : "unset",
        //backgroundColor: index % 2 == 0 ? "TRANSPARENT" : "#ebdfe2",
      }}
    >
      {question.displayTitle && question.titleType === 1 && (
        <b>{question.text}</b>
      )}
      <FormControl
        style={{ width: "100%", cursor: "pointer" }}
        variant="outlined"
      >
        {question.titleType === 2 && question.displayTitle === true && (
          <InputLabel htmlFor="outlined-adornment-password">
            {question.text}
          </InputLabel>
        )}
        <OutlinedInput
          readOnly
          multiline={true}
          minRows={1}
          onMouseDown={() => {
            console.log("onSelectonSelectonSelect" + question.code);
            //setFocuse(question.code);
            if (fileInfo.limitedFile === false) {
              openSelectList(question);
            }
          }}
          onTouchStart={() => {
            console.log("onSelectonSelectonSelect" + question.code);
            //setFocuse(question.code);
            if (fileInfo.limitedFile === false) {
              openSelectList(question);
            }
          }}
          // onClick={() => {
          //   if (fileInfo.limitedFile === false) {
          //     openSelectList(question);
          //   }
          // }}
          value={question.useranswerText}
          endAdornment={
            <InputAdornment position="end">
              <IconButton disabled={true}>
                <ExpandMoreIcon style={{ color: "#039dfc", height: 20 }} />
                {question.allowCopy &&
                  question.copyValue &&
                  renderAllowCopy(props)}
              </IconButton>
            </InputAdornment>
          }
          label={
            question.titleType === 2 && question.displayTitle == true
              ? question.text
              : null
          }
        />
      </FormControl>
      {question.helpPage && (
        <Button
          style={{
            marginTop: -10,
          }}
          onClick={() => {
            helpPage(question.helpPage);
          }}
          className="helplink"
          fullWidth={true}
        >
          <div
            style={{
              width: "100%",
              fontSize: 11,
              textAlign: "fa" == "fa" ? "left" : "right",
            }}
          >
            {question.helpText === ""
              ? getText("helptext", "fa")
              : question.helpText}
          </div>
        </Button>
      )}
    </Grid>
  );
}
